import React from "react";
import { axiosget } from "../../helpers/httprequest";
import swal from "../../helpers/swal";
import { useQueryClient } from "@tanstack/react-query";

const VerifyPayment = ({ v }) => {
  const [loading, setloading] = React.useState(false);
  const queryClient = useQueryClient();

  const _verify = async () => {
    try {
      setloading(true);
      const req = await axiosget(`ms_acceptance_fee_rrr/verify/${v?.acceptanceFee?.RRR}`);
      swal(req?.data?.type, req?.data?.message);
      if (req?.data?.type === "success") queryClient.invalidateQueries({ queryKey: ["acceptanceInformation"] });
      setloading(false);
    } catch ({ message }) {
      setloading(false);
    }
  };

  return (
    <button
      disabled={loading}
      className={`flex-1 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white font-semibold py-4 px-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-200 flex items-center justify-center gap-3 ${loading ? 'opacity-70 cursor-not-allowed' : ''}`}
      onClick={_verify}
    >
      {loading ? (
        <>
          <i className="fa fa-spinner fa-spin text-lg"></i>
          <span className="text-lg">Verifying Payment...</span>
        </>
      ) : (
        <>
          <i className="fa fa-check-circle text-lg"></i>
          <span className="text-lg">Verify Acceptance Fee Payment</span>
        </>
      )}
    </button>
  );
};

export default VerifyPayment;
